module.exports = __webpack_public_path__ + "static/media/ts3tj54.952246ef.png";